export const echo = {
    name: "echo",
    description: "Displays provided text",
    run: (args: string[]) => args.join(" ")
};